export const JOBS__DATA_PATH = '/json-data/jobs.json';
